import * as Yup from "yup";
import {
  CenterAddOnFormValues,
  LabelTranslationsKey,
} from "../CenterAddOnForm/types";

const getCenterAddOnFormSchema = (params: {
  labelTranslations: Record<LabelTranslationsKey, string>;
  maxStringLength: number;
  maxPrice: number;
}) => {
  const { labelTranslations, maxStringLength, maxPrice } = params;

  const requiredString = Yup.string().trim().max(maxStringLength).required();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return Yup.object().shape<Record<keyof CenterAddOnFormValues, any>>({
    name: requiredString.label(labelTranslations.labelName),
    price: Yup.number()
      .label(labelTranslations.labelPrice)
      .positive()
      .max(maxPrice)
      .required(),
    isStat: Yup.boolean().label(labelTranslations.labelStat).nullable(),
    isContactingPatientRequired: Yup.boolean().nullable(),
    marketingText: Yup.string()
      .label(labelTranslations.labelMarketingText)
      .trim()
      .max(1000)
      .required()
      .test("rich-text-not-empty", (value) => {
        const plain = value?.replace(/<[^>]*>/g, "").trim();
        return Boolean(plain);
      }),
    isPerStudyPricing: Yup.boolean()
      .label(labelTranslations.labelIsPerStudyPricing)
      .optional(),
    appliesTo: Yup.mixed()
      .oneOf(["appointment", "study"])
      .label(labelTranslations.labelAppliesTo),
    visibility: Yup.mixed()
      .oneOf(["public", "private"])
      .label(labelTranslations.labelVisibility)
      .required(),
    allowMultiplePurchases: Yup.boolean()
      .label(labelTranslations.labelAllowMultiplePurchases)
      .optional(),
  });
};

export default getCenterAddOnFormSchema;
